
import Vue from 'vue'

import { Category } from '@/model/category'

interface SidebarCategory {
  id: number
  category_name: string
  display_name: string
  url: string
}

export default Vue.extend({
  name: 'SidebarRelatedCategories',
  props: {
    current: {
      type: Object as () => Category,
      required: true
    },
    parent: {
      type: Object as () => Category,
      required: false,
      default: null
    },
    child: {
      type: Array as () => Category[],
      required: true
    },
    sibling: {
      type: Array as () => Category[],
      required: true
    },
    hasParent: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    parentCategory(): SidebarCategory {
      if (!this.hasParent) {
        return
      }

      const parentCategory = this.parent

      return {
        id: parentCategory.id,
        category_name: parentCategory.name,
        display_name: parentCategory.short_display_name,
        url: `/categories/${parentCategory.name}/`
      }
    },
    relatedCategories(): SidebarCategory[] {
      if (this.hasParent) {
        return this.createSidebarCategoryList(this.parent.name, this.sibling)
      }

      return this.createSidebarCategoryList(this.current.name, this.child)
    }
  },
  methods: {
    createSidebarCategoryList(
      rootCategoryName: string,
      categories: Category[]
    ): SidebarCategory[] {
      return categories.map(category => {
        return {
          id: category.id,
          category_name: category.name,
          display_name: category.short_display_name,
          url: `/categories/${rootCategoryName}/${category.name}/`
        }
      })
    }
  }
})
